module.exports = __webpack_public_path__ + "img/mantenimientos.7797d191.svg";